export const authRoutePaths = {
  login: {
    path: 'login',
    fullPath: '/login',
  },
  signUp: {
    path: 'sign-up',
    fullPath: '/sign-up',
  },
  resetPassword: {
    path: 'reset-password',
    fullPath: '/reset-password',
  },
  // TRAD-2249 — `terms`(약관 전문)는 policyRoutePaths.terms 로 옮겼다. 여기 남겨두면 다음
  // 사람이 "약관은 인증 그룹"으로 읽는다(URL 은 `/terms` 그대로).
  // TRAD-3790 — Android «애플로 로그인» 콜백(Apple redirect_uri). 앱 딥링크로 넘기기만 하는 중계 화면.
  appleAndroidCallback: {
    path: 'auth/apple/android-callback',
    fullPath: '/auth/apple/android-callback',
  },
  termsAgreement: {
    path: 'terms-agreement',
    fullPath: '/terms-agreement',
  },
};
